import React from 'react';
import { useRegisterModel } from './model';
import { RegisterView } from './view';

export const RegisterWidget: React.FC = () => {
  const { loading, referralCode, submit } = useRegisterModel();

  return <RegisterView loading={loading} referralCode={referralCode} onSubmit={submit} />;
};
